import { customElements } from "@scalar-org/guide-elements/elements";
const hydrateAll = (options) => {
  const hydrationFunctions = Object.values(customElements).map((el) => el.hydrate).filter((fn) => typeof fn === "function");
  return hydrationFunctions.reduce(
    (allSucceeded, fn) => fn(options) && allSucceeded,
    true
  );
};
export {
  hydrateAll
};
//# sourceMappingURL=index.js.map
